var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":_vm.$t('modals.product.cancelTitle'),"action":"update","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('cancel-form',{attrs:{"data":_vm.product}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }